export const activitybasic = {
    activityoutputstate: {
        service:{
        name:'activityoutputstate',
        title:'Activity Output State',
        }
    },
    activityplanstate: {
        service:{
        name:'activityplanstate',
        title:'Activity Plan State',
        }
    },
    activitytype: {
        service:{
        name:'activitytype',
        title:'Activity Type',
        }
    },
    activitystate: {
        service:{
        name:'activitystate',
        title:'Activity State',
        }
    },

    activitystatus: {
        service:{
        name:'activitystatus',
        title:'Activity Status',
        }
    },
}